import Component from "../../classes/Component";
import {$events} from "../../helpers/events";
import {$dom} from "../../helpers/dom";

const {toggleClass} = $dom

const favouriteDetailGroupSelector = '.js-favourite-detail-group'

const activeFavourite = 'detail__header-icon-active'

export default function () {
    const handleFavourite = (e) => {
        toggleClass(e.target.closest(favouriteDetailGroupSelector), activeFavourite)
    }

    return new Component({
        name: 'favourite',
        requiredTargets: [favouriteDetailGroupSelector],
        onInit() {
            $events.delegate.on('click', favouriteDetailGroupSelector, handleFavourite)
        },
        onDestroy() {
            console.log('favourite')
        },
    })

}